// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
    "名称":"名称",
    "价格":"价格",
    "今日涨跌幅":"今日涨跌幅",
    "提示":"提示",
    "功能正在开发，敬请期待！":"功能正在开发，敬请期待！",
    "关闭":"关闭",
    "请先登录":"请先登录",
    "无":"无",
    "首页":"首页",
    "行情":"行情",
    "资讯":"资讯",
    "我的":"我的",
    "上拉刷新":"上拉刷新",
    "释放更新":"释放更新",
    "加载中":"加载中",
    "意见反馈":"意见反馈",
    "语言切换":"语言切换",
	"在线客服":"在线客服",
    "安全退出":"安全退出",
    "推广码":"推广码",
    "交易记录":"交易记录",
    "修改登录密码":"修改登录密码",
    "修改支付密码":"修改支付密码",
    "实名认证":"实名认证",
    "出金":"出金",
    "入金":"入金",
    "转账":"转账",
    "持仓盈利":"持仓盈利",
    "资产":"资产",
    "手机":"手机",
    "英文":"英文",
    "中文简体":"中文简体",
    "最低":"最低",
    "最高":"最高",
    "买盘":"买盘",
    "卖盘":"卖盘",
    "交易":"交易",
    "更多":"更多",
    "请选择购买类型":"请选择购买类型",
    "市价":"市价",
    "取消":"取消",
    "对手价":"对手价",
    "委托价":"委托价",
    "同意":"同意",
    "请输入":"请输入",
    "买涨":"买涨",
    "买跌":"买跌",
    "平仓":"平仓",
    "分时":"分时",
    "分":"分",
    "时":"时",
    "日":"日",
    "周":"周",
    "月":"月",
    "你确定吗":"你确定吗",
    "弹出说明文本":"弹出说明文本",
    "委托价不能低于":"委托价不能低于",
    "手":"手",
    "确定交易":"确定交易",
    "新":"新",
    "卖":"卖",
    "买":"买",
    "持仓":"持仓",
    "挂单":"挂单",
    "成交":"成交",
    "合约名称":"合约名称",
    "手续费":"手续费",
    "多空":"多空",
    "总仓":"总仓",
    "可用":"可用",
    "开仓均价":"开仓均价",
    "浮盈":"浮盈",
    "操作":"操作",
    "空":"空",
    "多":"多",
    "开平":"开平",
    "买开":"买开",
    "撤单":"撤单",
    "成交价":"成交价",
    "成交量":"成交量",
    "成交时间":"成交时间",
    "卖开":"卖开",
    "排队价":"排队价",
    "最新价":"最新价",
    "超价":"超价",
    "token值错误！":"token值错误！",
    "买入":"买入",
    "卖出":"卖出",
    "确定要撤单":"确定要撤单",
    "确定要手动平仓":"确定要手动平仓",
    "登录":"登录",
    "部分信息未填写":"部分信息未填写",
    "短信验证":"短信验证",
    "找回密码":"找回密码",
    "忘记密码":"忘记密码",
    "暂无数据":"暂无数据",
    "账户列表":"账户列表",
    "立即登录":"立即登录",
    "是否记住密码":"是否记住密码",
    "登录密码":"登录密码",
    "密码":"密码",
    "客户号":"客户号",
    "账号":"账号",
    "两组密码不相同":"两组密码不相同",
    "手机号":"手机号",
    "确认":"确认",
    "确认新登录密码":"确认新登录密码",
    "设置新登录密码":"设置新登录密码",
    "获取验证码":"获取验证码",
    "验证码":"验证码",
    "登录成功":"登录成功",
    "短信登录":"短信登录",
    "加载失败":"加载失败",
    "加载完成":"加载完成",
    "数据加载中":"数据加载中",
    "发送内容不能为空":"发送内容不能为空",
    "上拉加载更多":"上拉加载更多",
    "提交":"提交",
    "内容":"内容",
    "状态":"状态",
    "待审核":"待审核",
    "审核通过":"审核通过",
    "审核拒绝":"审核拒绝",
    "说明":"说明",
    "姓名":"姓名",
    "身份证编号":"身份证编号",
	"原支付密码":"原支付密码",
    "确认新支付密码":"确认新支付密码",
    "新支付密码":"新支付密码",
    "原登录密码":"原登录密码",
    "买卖":"买卖",
    "手数":"手数",
    "平仓盈亏":"平仓盈亏",
    "查询":"查询",
    "至":"至",
    "注册":"注册",
    "推荐人":"推荐人",
    "设置登录密码":"设置登录密码",
    "确认登录密码":"确认登录密码",
    "已阅读并同意":"已阅读并同意",
    "风险提示":"风险提示",
    "立即开户":"立即开户",
    "邮箱":"邮箱",
    "只能英文和数字":"只能英文和数字",
    "请同意交易协议":"请同意交易协议",
    "提现记录":"提现记录",
    "提现金额":"提现金额",
    "提交时间":"提交时间",
    "备注":"备注",
    "充值金额":"充值金额",
    "充值记录":"充值记录",
    "链地址":"链地址",
    "支付密码":"支付密码",
    "重要提示":"重要提示",
    "币种":"币种",
    "您的个人多重签名":"您的个人多重签名",
    "入金地址":"入金地址",
    "存为图片":"存为图片",
    "凭证":"凭证",
    "成功":"成功",
    "转入":"转入",
    "转出":"转出",
    "未知":"未知",
    "转账记录":"转账记录",
    "对方账号":"对方账号",
    "转账金额":"转账金额",
    "复制":"复制",
    "均价":"均价",
    "涨幅":"涨幅",
    "开盘价":"开盘价",
    "收盘价":"收盘价",
    "最低价":"最低价",
    "最高价":"最高价",
    "K线周期图表":"K线周期图表",
    "昵称":"昵称",
    "邮箱验证":"邮箱验证",
    "邮箱登录":"邮箱登录",
    "我的推广二维码":"我的推广二维码",
    "推广": "将您的推广链接分享给好友注册，有效交易500USDT可享高额佣金88USDT",
    "复制推广链接":"复制推广链接",
    "复制成功":"复制成功",
    "资产不足":"资产不足",
    "快捷买币":"快捷买币",
    "轻松购买数字资产":"轻松购买数字资产",
    "约":"约",
    "杠杆倍数":"杠杆倍数",
    "倍":"倍",
    "请先设置支付密码":"请先设置支付密码",
    "止损":"止损",
    "止盈":"止盈",
    "开仓":"开仓",
    "买平":"买平",
    "卖平":"卖平",
    "时间":"时间",
    "不能小于":"不能小于",
    "当前价":"当前价",
}


// WEBPACK FOOTER //
// ./src/plugins/lang/zh-cn.js